import startOfDay from '@teetsh/app/src/utils/time/startOfDay';
import isSameDay from '@teetsh/app/src/utils/time/isSameDay';
import addMinutes from '@teetsh/app/src/utils/time/addMinutes';
import { format } from '@teetsh/app/src/utils/time/format';
import { timeFormat } from '@teetsh/app/src/components/Form/TimePicker2/InputTimePicker';
import { UserLocale } from '@teetsh/app/src/types/user';
import { getFloorStepTime } from './getFloorStepTime';

export function getMinutesRanges(
  locale: UserLocale,
  timeGap: number,
  min?: Date,
): string[] {
  const start = min ? getFloorStepTime(min, timeGap) : startOfDay(new Date());

  function getDate(ongoingDate: Date, acc: string[]): string[] {
    if (isSameDay(ongoingDate, start)) {
      return getDate(addMinutes(ongoingDate, timeGap), [
        ...acc,
        format(ongoingDate, locale, timeFormat),
      ]);
    }
    return acc;
  }

  return getDate(addMinutes(start, timeGap), []);
}
